export function PopupList(text: string): any {
	// eslint-disable-next-line no-useless-escape
	let matches = text.match(/{{\s*[\w\.]+\s*}}/g);
	if (matches !== null) {
		return matches.map(function(x) {
			// eslint-disable-next-line no-useless-escape
			return x.match(/[\w\.]+/)![0];
		});
	} else {
		return null;
	}
}